export default __webpack_public_path__ + "static/media/195.d42e5595.png";